export const signUpFormUrl =
  'https://docs.google.com/forms/d/1wuc8Y4cjxwiMRy3naIKQ1p4gNe7fuMhWwpmSpjXqk7U/viewform'
